import Api from '@/api'

const jsgl = {
  data() {
    return {}
  },
  methods: {
    jwglGo(type) {
      console.log(type, this.currTab.relativeId);
      if (type === 1 && this.currTab && this.currTab.relativeId) {
        this.translateActive(this.currTab.relativeId, true, undefined, true)
      }
    },
    reviseRole() {
      const vm = this
      const pid = this.miTableBtn.id
      const type = this.miTableBtn.roleType;
      const data = {
        type,
        id: this.rowData.id
      }
      for (const key in this.$refs) {
        if (key.indexOf(pid) > -1 && this.$refs[key].length) {
          const vc = this.$refs[key][0]
          const name = vc.params.label
          const ikey = vc.params.key
          const value = vc.getValue()
          console.log(name, ikey, value)
          if (value && ikey === 'area') {
            if (Number(value.radio) === 1) {
              data.radio = value.radio
            } else if (Number(value.radio) === 2) {
              // data.radio = value.radio
              if (!value[ikey] || !value[ikey].provience) {
                return this.$message.error('请选择适用范围: 省市区县')
              } else if (!value[ikey] || !value[ikey].city) {
                return this.$message.error('请选择适用范围: 市区县')
              } else if (!value[ikey] || !value[ikey].area) {
                return this.$message.error('请选择适用范围: 区县')
              } else {
                data[type==1?'provinceId':type==2?'dispatcherProvinceId':'superviseProvinceId'] = value[ikey].provience
                data[type==1?'cityId':type==2?'dispatcherCityId':'superviseCityId'] = value[ikey].city
                data[type==1?'regionId':type==2?'dispatcherRegionId':'superviseRegionId'] = value[ikey].area
              }
            }
          } else if (value && (value[ikey] || value[ikey] === 0) && ikey !== 'area') {
            data[ikey] = value[ikey]
          } else {
            return this.$message.error('请填写' + name.replace(':', '').replace('：', ''))
          }
        }
      }
      const params = {
        selfAreaId: vm.selfAreaId
      }
      Api.fetchApiPost(data, params, vm.miTableBtn.api)
        .then(res => {
          // 刷新页面
          if (res && res.code === 200) {
            vm.$message.success('角色修改保存成功!')
            vm.onCloseDialog()
            const currTab = vm.configJs.find(item => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch(err => {
          console.log('reviseRole', err)
        })
    },
  }
}

export default jsgl
